/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExerciseConfig } from './ExerciseConfig';
import {
    ExerciseConfigFromJSON,
    ExerciseConfigFromJSONTyped,
    ExerciseConfigToJSON,
    ExerciseConfigToJSONTyped,
} from './ExerciseConfig';

/**
 * 
 * @export
 * @interface UpdateDeckExerciseDTO
 */
export interface UpdateDeckExerciseDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeckExerciseDTO
     */
    deckId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeckExerciseDTO
     */
    exerciseId: string;
    /**
     * 
     * @type {ExerciseConfig}
     * @memberof UpdateDeckExerciseDTO
     */
    exerciseConfig?: ExerciseConfig;
}

/**
 * Check if a given object implements the UpdateDeckExerciseDTO interface.
 */
export function instanceOfUpdateDeckExerciseDTO(value: object): value is UpdateDeckExerciseDTO {
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('exerciseId' in value) || value['exerciseId'] === undefined) return false;
    return true;
}

export function UpdateDeckExerciseDTOFromJSON(json: any): UpdateDeckExerciseDTO {
    return UpdateDeckExerciseDTOFromJSONTyped(json, false);
}

export function UpdateDeckExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDeckExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'deckId': json['deckId'],
        'exerciseId': json['exerciseId'],
        'exerciseConfig': json['exerciseConfig'] == null ? undefined : ExerciseConfigFromJSON(json['exerciseConfig']),
    };
}

export function UpdateDeckExerciseDTOToJSON(json: any): UpdateDeckExerciseDTO {
    return UpdateDeckExerciseDTOToJSONTyped(json, false);
}

export function UpdateDeckExerciseDTOToJSONTyped(value?: UpdateDeckExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deckId': value['deckId'],
        'exerciseId': value['exerciseId'],
        'exerciseConfig': ExerciseConfigToJSON(value['exerciseConfig']),
    };
}

